module.exports = __webpack_public_path__ + "onboard-square-3aa7f2507d20f992efed2cd6ad90b695.png";